import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { GlitterCartItemDto, CartState, GlitterCartDto } from '../api/cartDto';
import { GlitterOfferBaseDto } from '../api/glitterOfferBaseDto';
import { ExchangeService } from './exchange.service';
import { ComponentWithOnDestroyObservable, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

type Cart = Map<GlitterOfferBaseDto, number>
@Injectable({
	providedIn: 'root'
})
export class ExchangeCartService {
	private cartSource: BehaviorSubject<Cart>;
	private cart$: Observable<Cart>;
	private cartState: BehaviorSubject<CartState>;
	cartState$: Observable<CartState>;

	constructor(private exchangeService: ExchangeService) {
		this.cartSource = new BehaviorSubject<Map<GlitterOfferBaseDto, number>>(new Map());
		this.cart$ = this.cartSource.asObservable();
		this.cartState = new BehaviorSubject<CartState>(null);
		this.cartState$ = this.cartState.asObservable();
	}

	getCart(component: ComponentWithOnDestroyObservable): Observable<Cart> {
		const ret = this.cart$.pipe(untilComponentDestroyed(component))
		this.exchangeService.getExchangeCart()
			// .pipe(untilComponentDestroyed(component))
			.subscribe(result => {
				this.initCart(result);
			});
		return ret;
	}

	initCart(response: GlitterCartDto) {
		const cartCopy = new Map();
		response.items.forEach((cartItem: GlitterCartItemDto) => {
			cartCopy.set(cartItem.offer, cartItem.qty);
		});
		this.cartSource.next(cartCopy);
		this.cartState.next(response.state);
	}

	addItemToCart(item: GlitterOfferBaseDto, quantity = 1) {
		this.exchangeService.addToCart(item.id).subscribe(() => {
			const cartCopy = new Map(this.cartSource.getValue());
			const existingItem = Array.from(cartCopy.keys()).find(glitterPackage => glitterPackage.id === item.id);
			const glitter = existingItem || item;
			glitter.remainingQty --
			const alreadyInCart = cartCopy.get(glitter) || 0;
			cartCopy.set(glitter, alreadyInCart + quantity);
			this.cartSource.next(cartCopy);
		});
	}

	deleteItemFromCart(item: GlitterOfferBaseDto) {
		this.exchangeService.removeFromCart(item.id).subscribe(() => {
			const cartCopy = new Map(this.cartSource.getValue());
			const existingItem = Array.from(cartCopy.keys()).find(glitterPackage => glitterPackage.id === item.id);
			const glitter = existingItem || item;
			const alreadyInCart = cartCopy.get(glitter) || 0;
			if (alreadyInCart > 1) {
				cartCopy.set(glitter, alreadyInCart - 1);
			} else {
				cartCopy.delete(glitter);
			}
			glitter.remainingQty ++
			this.cartSource.next(cartCopy);
		});
	}

	emptyCart() {
		this.cartSource.next(new Map());
	}
}